






























































import { Component, Prop, Vue } from "vue-property-decorator";
import * as moment from "moment";
import { PostsApi } from "../../../apis";
@Component({
  components: {},
})
export default class AdminAboutUs extends Vue {
  itemsLanguage = ["English", "Tiếng Việt"];
  language = "Tiếng Việt";
  editor = "";
  imageUrl = "";
  titleHeader = "";
  createdAt = "";
  updatedAt = "";
  headerImageHeight = "100%";
  getEdit() {
    this.$router.push({ name: "edit-about" });
  }
  mounted() {
    this.getAbout();
  }

  async getAbout() {
    this.$util.showLoading();
    try {
    const res = await new PostsApi().getAboutPost();
    const response = res.data.data[0];

    if (this.$store.getters.locale === "en") {
      this.imageUrl = response.headerUrlEn;
      this.editor = response.contentEn;
      this.titleHeader = response.subjectEn;
    }
    if (this.$store.getters.locale === "vi") {
      this.imageUrl = response.headerUrlVn;
      this.editor = response.contentVn;
      this.titleHeader = response.subjectVn;
    }
    this.createdAt = response.createdAt;
    this.createdAt = moment(this.createdAt).format("DD/MM/YYYY HH:mm");
    this.updatedAt = response.updatedAt;
    this.updatedAt = moment(this.updatedAt).format("DD/MM/YYYY HH:mm");
    } catch (error) {
    } finally {
      this.$util.hideLoading();
    }
  }
  onLoadImageCompleted(event) {
    const headerImageEle = document.getElementById("header-img");
    if (headerImageEle) {
      this.headerImageHeight = "" + headerImageEle.offsetHeight;
      headerImageEle.classList.add("tw-hidden");
    }
  }
}
